import { render, staticRenderFns } from "./WidgetActivityApply.vue?vue&type=template&id=04edd07c&scoped=true&"
import script from "./WidgetActivityApply.vue?vue&type=script&lang=js&"
export * from "./WidgetActivityApply.vue?vue&type=script&lang=js&"
import style0 from "./WidgetActivityApply.vue?vue&type=style&index=0&id=04edd07c&lang=scss&scoped=true&"
import style1 from "./WidgetActivityApply.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04edd07c",
  null
  
)

export default component.exports